import { RESET_STATE } from 'store/global/actions';
import { HOUSING_FINANCE_AGENCIES_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = [];

const housingFinanceAgenciesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HOUSING_FINANCE_AGENCIES_ACTION_TYPE.GET_HOUSING_FINANCE_AGENCIES:
      return payload;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default housingFinanceAgenciesReducer;
